import { useLayoutEffect } from 'react';

import { useSetWillRedirectOnLoad } from '../use-set-will-redirect-on-load';
import { useWillRedirectOnLoad } from '../use-will-redirect-on-load';

export const useRedirectOnLoad = <T,>(href: T, redirect: (href: T) => void, condition = true) => {
	const willRedirectOnLoad = useWillRedirectOnLoad();
	const setWillRedirectOnLoad = useSetWillRedirectOnLoad();

	useLayoutEffect(() => {
		if (condition && willRedirectOnLoad) {
			setWillRedirectOnLoad(false);
			redirect(href);
		}
	}, [condition, href, redirect, setWillRedirectOnLoad, willRedirectOnLoad]);
};
